export const getBarsHeight = value => {
  const maxBarHeigth = 48;
  return value * maxBarHeigth;
};
